module.exports = __webpack_public_path__ + "media/images/Stars-c730fc78497429c70d2a3af5d2f33cb1.svg";